import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getWiPayConfig = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/wipay-config/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("WiPay config fetch error:", error);
    throw error;
  }
};

const updateWiPayConfig = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/wipay-config/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("WiPay config update error:", error);
    throw error;
  }
};

export { getWiPayConfig, updateWiPayConfig };
